import React from 'react';
import HemisphereDisplay from './HemisphereDisplay';

 
class Main extends React.Component{

	state={latitude:null,errorMessage:''}

	componentDidMount(){
        window.navigator.geolocation.getCurrentPosition(
		(position)=>{
		this.setState({latitude:position.coords.latitude})
		},
		(error)=>{
		this.setState({errorMessage:error.message})
		}
		);
	}
	componentDidUpdate(){
		console.log('Updated')
	}
	render(){
		if(this.state.errorMessage && !this.state.latitude){
			return(
			<div className='ui comments'>
			 {this.state.errorMessage}
			</div>)
		}
		if(!this.state.errorMessage && this.state.latitude){
			return(
			<div >
			 <HemisphereDisplay latitude={this.state.latitude} />
			</div>
				)
		}
		else{
			return(
			<div className='ui comments'>
			 loading..
			</div>
				)
		}
	}
}

export default Main;